import styled from 'styled-components';

const Styles = styled.div`
display: flex;
color: var(--color-primary);
font-size: 14px;
padding: 5px;
border-radius: 3px;
width: fit-content;

.error{
    border-bottom: solid 1px var(--color-primary-opposite);
}

.success{
    border-bottom: solid 1px var(--color-primary-light);
}
`

const MessageBox = props => {
    const { message, isSuccess } = props;

    return <Styles>
        <span className={isSuccess ? 'success' : 'error'}>{message}</span>
    </Styles>
}
export default MessageBox;